import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8e718502&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8e718502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e718502",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Operate: require('C:/Users/xiao9/Desktop/projects/web-tattoo-workspace/components/operate.vue').default,Draw: require('C:/Users/xiao9/Desktop/projects/web-tattoo-workspace/components/draw.vue').default})
